module.exports = __webpack_public_path__ + "img/ending_value_icon.png";